import filtrosLotes from './filtrosLotes';
import filtrosProjetos from './filtrosProjetos';
import filtrosProjetosLote from './filtrosProjetosLote';
import filtrosClientesRurais from './filtrosClientesRurais';

export default {
  namespaced: true,
  modules: {
    filtrosLotes,
    filtrosProjetos,
    filtrosProjetosLote,
    filtrosClientesRurais,
  },
};
